import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Aboutus from './Website/pages/aboutus/Aboutus';
import './App.css';
import Product from './Website/pages/product/Product';
import ProdDescription from './Website/pages/prodDescription/ProdDescription';
import Navbar from './Website/components/maincomps/navbar/Navbar';
import Home from './Website/pages/home/Home';
import Footer from './Website/components/maincomps/footer/Footer';
import Wishlist from './Website/pages/wishlist/Wishlist';
import CartPage from './Website/pages/cartpage/CartPage';
import Emptywishlist from './Website/pages/emptywishlist/Emptywishlist';
import Emptycart from './Website/pages/emptycart/Emptycart';
import Offer from './Website/pages/Offer/Offer';
import Checkout from './Website/pages/checkout/Checkout';
import FAQ from './Website/pages/faq/FAQ';
// import MetroGuide from './Website/pages/metro/MetroGuide';
import PaymentFailed from './Website/components/paymentfailed/PaymentFailed';
import CouponPopup from './Website/components/couponpopup/CouponPopup';
import Welcome from './Website/emailtemplates/wlecome/Welcome';
import ThankyouPopup from './Website/components/thankyoupopup/ThankyouPopup';
import Thankyou from './Website/emailtemplates/thankyou/Thankyou';
import Contact from './Website/pages/contact/Contact';
import ErrorPage from './Website/pages/errorpage/ErrorPage';
import TermsCondition from './Website/pages/terms-policy/TermsCondition';
import PrivacyPolicy from './Website/pages/terms-policy/PrivacyPolicy';
import ReturnRefund from './Website/pages/terms-policy/ReturnRefund';
import ShippingPolicy from './Website/pages/terms-policy/ShippingPolicy';
import Goldrate from './Website/components/Goldrate/Goldrate';
import Breadcrumbs from './Website/components/maincomps/breadcrumbs/Breadcrumbs';
import Verification from './Website/emailtemplates/verification/Verification';
import Myprofile from './Dashboard/pages/myprofile/Myprofile';
import Orders from './Dashboard/pages/orders/Orders';
import OrderDetails from './Dashboard/pages/orderdetails/OrderDetails';
import CreateAccount from './Website/auth/createAccount/CreateAccount';
import EmptyAddress from './Dashboard/pages/emptyaddress/EmptyAddress';
import Editprofile from './Dashboard/pages/editprofile/Editprofile';
import { useDispatch, useSelector } from 'react-redux';
import { getProfile } from './redux/userSlice';
import ShippingAddress from './Dashboard/pages/shippingaddress/ShippingAddress';
import ProfileBody from './Dashboard/components/profilebody/ProfileBody';
import SignIn from './Website/auth/signin/SignIn';
import Otp from './Website/auth/otp/Otp';
import { Success } from './Website/auth/success/Success';
import Invoice from './Website/pages/Invoice/Invoice';
import ProductsWithSubCategory from './Website/pages/product/ProductsWithSubCategory';
import InternationalPolicy from './Website/pages/terms-policy/InternationalPolicy';
import LoginWithMail from './Website/auth/signin/LoginWithMail';
import Cookies from './Website/components/maincomps/cookies/Cookies';
import SearchedProduct from './Website/components/maincomps/navbar/SearchedProduct';

const App = () => {
  const location = useLocation();
  const dispatch = useDispatch()
  const excludedPaths = ["/", "/aboutus"];
  const token = localStorage.getItem("token");
  const { refresh } = useSelector(state => state.user)

  useEffect(() => {
    if (token) {
      dispatch(getProfile())
    }
  }, [token, refresh])

  return (
    <>
      <Navbar />
      {/* {!excludedPaths.includes(location.pathname) && <Breadcrumbs />} */}
      <SignIn />
      <CreateAccount />
      <LoginWithMail/>
      <Otp />
      <Success />
      <Routes>


        {/* <Route path="/createAccount" element={<CreateAccount />} /> */}

        <Route path="/" element={<Home />} />
        <Route path="/aboutus" element={<Aboutus />} />
        <Route path="/product/:id" element={<Product />} />
        <Route path="/prodDescription/:id" element={<ProdDescription />} />
        <Route path="/wishlist" element={<Wishlist />} />
        <Route path="/cart" element={<CartPage />} />
        <Route path="/emptywishlist" element={<Emptywishlist />} />
        <Route path="/emptycart" element={<Emptycart />} />
        <Route path="/offer" element={<Offer />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/faq" element={<FAQ />} />
        {/* <Route path="/metro-guide" element={<MetroGuide />} /> */}
        <Route path="/thankyouPopup" element={<ThankyouPopup />} />
        <Route path="/paymentFailed" element={<PaymentFailed />} />
        <Route path="/loginwithmail" element={<LoginWithMail />} />
        <Route path="/couponPopup" element={<CouponPopup />} />
        <Route path="/welcome" element={<Welcome />} />
        <Route path="/thankyou" element={<Thankyou />} />
        <Route path="/Verification" element={<Verification />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/errorPage" element={<ErrorPage />} />
        <Route path="/termsCondition" element={<TermsCondition />} />
        <Route path="/returnRefund" element={<ReturnRefund />} />
        <Route path="/privacyPolicy" element={<PrivacyPolicy />} />
        <Route path="/shippingPolicy" element={<ShippingPolicy />} />
        <Route path="/internationalPolicy" element={<InternationalPolicy />} />
        <Route path="*" element={<ErrorPage />} />
        <Route path="/myprofile" element={<ProfileBody />} />
        <Route path="/editprofile" element={<Editprofile />} />
        <Route path="/orders" element={<Orders />} />
        <Route path="/orderDetails/:id" element={<OrderDetails />} />
        <Route path="/shippingAddress" element={<ShippingAddress />} />
        <Route path="/emptyAddress" element={<EmptyAddress />} />
        <Route path="/invoice/:id" element={<Invoice />} />
        <Route path="/productsWithSubCategory/:id" element={<ProductsWithSubCategory />} />
        <Route path="/SearchedProduct" element={<SearchedProduct />} />
      </Routes>
      <Footer />
      <Cookies/>
    </>
  );
};

export default App;
